/* bm-extension-arms: waitlist form. Behaviour ported from the retired nano-coming-soon section:
   same endpoint, method, JSON field names, honeypot (hp_url), minimum form age and 204 handling. */
(function () {
  var root = document.getElementById('extension-arms-main');
  if (!root || root.dataset.bound === '1') return;
  root.dataset.bound = '1';

  var form = root.querySelector('[data-ea-form]');
  var btn = root.querySelector('[data-ea-submit]');
  var err = root.querySelector('[data-ea-error]');
  var done = root.querySelector('[data-ea-done]');
  if (!form || !btn || !err || !done) return;

  var T = {};
  try { T = JSON.parse(document.getElementById('ea-i18n').textContent) || {}; } catch (e) { T = {}; }
  function t(key, fallback) { return typeof T[key] === 'string' && T[key] ? T[key] : fallback; }

  var ENDPOINT = 'https://pipeline.futuremvmt.com/dashboard-api/api/public/preorder-waitlist';
  var PRODUCT = 'speediance-extension-arms';
  var SOURCE = 'extension-arms-coming-soon';
  var MIN_AGE = 1600;
  var renderedAt = Date.now();
  var label = btn.textContent;
  var IS_EN = /^en/i.test(document.documentElement.lang || '');
  btn.disabled = false; // ships disabled so a visitor without this script cannot submit the form

  function fail(m) { err.textContent = m; err.hidden = false; }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    err.hidden = true;
    var f = form.elements;
    ['name', 'email', 'phone', 'postcode'].forEach(function (n) { f[n].removeAttribute('aria-invalid'); });
    function bad(el, msg) {
      el.setAttribute('aria-invalid', 'true');
      el.focus();
      fail(msg);
      return false;
    }
    function ok(el) { el.removeAttribute('aria-invalid'); }

    var name = (f.name.value || '').trim();
    var email = (f.email.value || '').trim();
    var phone = (f.phone.value || '').trim();
    var phoneDigits = phone.replace(/[^0-9]/g, '');
    var postcode = (f.postcode.value || '').trim();

    // Validate in visual order and stop at the first miss.
    if (name.length < 2) return bad(f.name, t('error_name', 'Please enter your name.'));
    ok(f.name);
    if (!/^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(email)) return bad(f.email, t('error_email', 'Please enter a valid email address.'));
    ok(f.email);
    if (phoneDigits.length < 6 || phoneDigits.length > 20) return bad(f.phone, t('error_phone', 'Please enter a valid phone number.'));
    ok(f.phone);
    if (postcode.length < 2 || postcode.length > 16) return bad(f.postcode, t('error_postcode', 'Please enter your postcode.'));
    ok(f.postcode);

    var age = Date.now() - renderedAt;
    if (age < MIN_AGE) age = MIN_AGE;

    btn.disabled = true;
    btn.textContent = t('busy', 'Adding you...');

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product: PRODUCT,
        source: SOURCE,
        name: name,
        email: email,
        phone: phone,
        postcode: postcode,
        marketing_consent: true,
        hp_url: form.elements.hp_url.value,
        form_age_ms: age
      })
    }).then(function (r) {
      // 204 is the honeypot's silent drop; answer it like success so a filler learns nothing.
      if (r.status === 204) return {};
      return r.json().catch(function () { return {}; }).then(function (p) {
        if (!r.ok) { var er = new Error(IS_EN && r.status === 400 && p.error ? p.error : t('error_generic', 'Something went wrong. Please try again.')); er.ea = true; throw er; }
        return p;
      });
    }).then(function () {
      form.hidden = true;
      done.hidden = false;
      if (done.focus) done.focus();
    }).catch(function (e2) {
      btn.disabled = false;
      btn.textContent = label;
      fail(e2 && e2.ea ? e2.message : t('error_generic', 'Something went wrong. Please try again.'));
    });
  });
})();
